import { render, staticRenderFns } from "./GogoReactRuntimeWrapper.vue?vue&type=template&id=709aee46"
import script from "./GogoReactRuntimeWrapper.vue?vue&type=script&lang=ts"
export * from "./GogoReactRuntimeWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports